export default "__VITE_ASSET__Bo7JhAIu__"